<div class="row" *ngIf="singleDevice">
    <div class="col-12">
        <h6 class=" muted-color hightText">{{ device.SubArea }}</h6>
    </div>
</div>

<div class="row" style="overflow: hidden;">
    <div [ngClass]="{ 'col-md-4': !singleDevice, 'col-md-5': singleDevice }" class="col-sm-10">
        <div class="row">
            <div class="col-12">
                <span class="normalText muted-color"> {{ 'DEVICE_VIEW.LABEL1' | translate }} </span><span class="hightText"><span
                        class="ms-1 muted-color-2">{{device.SRNumber}}</span></span>
            </div>
            <div class="col-12">
                <span class="normalText muted-color"> {{ 'DEVICE_VIEW.LABEL2' | translate }} </span> <span class="hightText"><span
                        class="ms-1 muted-color-2">{{device.TipoAclaracion}}</span></span>
            </div>
            <div class="col-12">
                <span class="normalText muted-color"> {{ 'DEVICE_VIEW.LABEL3' | translate }} </span> <span class="hightText"><span
                        class="ms-1 muted-color-2">{{device.Abstract}}</span></span>
            </div>
            <div class="col-12">
                <span class="normalText muted-color"> {{ 'DEVICE_VIEW.LABEL4' | translate }} </span><span class="hightText"><span
                        class="ms-1 muted-color-2">{{device.Area}}</span></span>
            </div>
            <div class="col-12">
                <span class="normalText muted-color"> {{ 'DEVICE_VIEW.LABEL5' | translate }} </span><span class="hightText"><span
                        class="ms-1 muted-color-2">{{device.R3Fechaservicio }}</span></span>
            </div>
            <div class="col-12">
                <span class="normalText muted-color"> {{ 'DEVICE_VIEW.LABEL6' | translate }} </span><span class="hightText"><span
                        class="ms-1 muted-color-2">{{device.EstadoGarantia}}</span></span>
            </div>
        </div>
    </div>

    <hr class="divider d-sm-inline-block d-md-none mt-3 mb-3" *ngIf="singleDevice" />

    <div [ngClass]="{ 'col-md-3': !singleDevice, 'col-md-6': singleDevice }" class="col-sm-10">
        <div class="row">
            <div class="col-12">
                <span class="normalText muted-color"> {{ 'DEVICE_VIEW.LABEL7' | translate }} </span> <span class="hightText"><span
                        class="ms-1 muted-color-2">{{device.R3Fechaservicio}}</span></span>
            </div>
            <div class="col-12">
                <span class="normalText muted-color"> {{ 'DEVICE_VIEW.LABEL8' | translate }} </span> <span class="hightText"><span
                        class="ms-1 muted-color-2">{{device.R3Fechaterminollamada}}</span></span>
            </div>
            <div class="col-12">
                <span class="normalText muted-color"> {{ 'DEVICE_VIEW.LABEL9' | translate }} </span> <span class="hightText"><span
                        class="ms-1 muted-color-2">{{device.R3Fechaterminollamada}}</span></span>
            </div>
            <div class="col-12">
                <span class="normalText muted-color"> {{ 'DEVICE_VIEW.LABEL10' | translate }} </span> <span class="hightText"><span
                        class="ms-1 muted-color-2">{{device.R3Fechaasignacion}}</span></span>
            </div>
        </div>
    </div>

    <div class="offset-md-0 col-sm-12 col-md-3 align-self-start mt-3 d-flex d-sm-flex justify-content-center" *ngIf="!singleDevice && claimHistory && claimHistory.length > 0">
        <span class="primary-color normalText" (click)="deviceHistory.toggle()" style="cursor:pointer;"> {{ 'DEVICE_VIEW.LABEL11' | translate }} </span>
    </div>
    <div class="offset-md-0 col-sm-12 col-md-3 align-self-start mt-3 d-flex d-sm-flex justify-content-center" *ngIf="!singleDevice && claimHistory && claimHistory.length <= 0">
    </div>
    <div class="col-sm-12 col-md-2 align-self-start text-end mt-2" *ngIf="!singleDevice && device.ShowButton">
        <button mat-stroked-button class="text-wrap d-none d-sm-none d-md-inline " color="primary"  [disabled]="device.DisableButton"
            routerLink="service/{{device.SRNumber}}">
            {{ 'DEVICE_VIEW.LABEL12' | translate }} 
        </button>
    </div>
    <div class="col-12" *ngIf="!singleDevice">
        <app-device-history [device]="device" [claimHistory]="claimHistory" ></app-device-history>
    </div>
    <div class="col-sm-12 col-md-2 align-self-start text-end p-0" *ngIf="!singleDevice && device.ShowButton">
        <button mat-stroked-button color="primary" class="w-100 d-block d-sm-block d-md-none"
            style="white-space: break-spaces;" routerLink="service/{{device.SRNumber}}" [disabled]="device.DisableButton">
            {{ 'DEVICE_VIEW.LABEL12' | translate }} 
        </button>
    </div>

</div>